import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'linha',
    standalone: false
})
export class LinhaPipe implements PipeTransform {

  transform(telefone: string): any {

    return '(' + telefone.substr(0,2) + ') ' + telefone.substr(2,5) + '-' + telefone.substr(7,4);

  }

}
